import { render, staticRenderFns } from "./quan.vue?vue&type=template&id=aab5f968&scoped=true"
import script from "./quan.vue?vue&type=script&lang=js"
export * from "./quan.vue?vue&type=script&lang=js"
import style0 from "./quan.vue?vue&type=style&index=0&id=aab5f968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab5f968",
  null
  
)

export default component.exports